<template>
	<main v-if="info">
		<div class="main">
      <dl class="titleTip">
        <dt>
          <span  style="color:#666;cursor: pointer" @click="$router.go(-1)">指南规范 ></span>
          <span> 指南规范详情</span>
        </dt>
        <dd></dd>
      </dl>
			<div class="mainBox">
				<h2>{{info.name}}</h2>
        <div class="time">
          {{info.time}}
        </div>
				<div class="content" v-html="info.content">
        </div>
			</div>
		</div>
	</main>
</template>
<script>
	export default {
		name: 'Article',
		data() {
			return {
				name: '',
				time: '',
				content: '',
        ClinicalId: '',
        dateList: [],
        info: null
			}
		},
		created() {
			const ClinicalId = this.$route.query.ClinicalId;
			this.ClinicalId = ClinicalId;
			this.getArticleDtails();
		},
		methods: {
			getArticleDtails() {
				const articleId = this.ClinicalId;
				const params = {
          ClinicalId: this.ClinicalId,
				}
				this.$api.getQcDataList(params).then(r => {
					if (r.code === 1) {
						this.dateList = r.data.data
            let o = this.dateList.find((v) => {
              return v.id == this.ClinicalId
            })
            console.log(o)
            this.info = o
					}
				})
			},
		},
		computed: {

		},
		watch: {

		},
	}

</script>
<style lang="scss" scoped>
	@import './qcList.scss';
</style>
